import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  ...ItemsConfig,
  componentId: 'wipParts',
  entity: 'wipPart',
  filtersFetchData: { wipPart: { isAlive: true } },
};
const WipParts = props => {
  const defaultProps = {
    flavorId: 'wipPart',
    title: 'Wip Parts',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };
  return <Items configComponent={defaultConfigComponent} {...props} {...defaultProps} />;
};

export default WipParts;
